import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../../../components/layout/NavBar";
import Sidebar from "./Sidebar";
import LocationConsentGate from "../../features/attendance/LocationConsentGate";
import ToastProvider from "../ui/ToastProvider";
import usePermissions from "../../../hooks/usePermissions";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { setLastView } from "../../../utils/viewPreference";
import { cx } from "../../utils/classNames";
import styles from "./Layout.module.css";
import "../../styles/global.css";

// My view shell (every /me page). Shared top bar with the HR view (profile,
// logout, view toggle); the employee sidebar; the location-consent prompt.
// Phones: the sidebar is a slide-in menu opened from the top bar's hamburger.
// Route guard (RequireEmployee) runs before this, so there's an employee.
const Layout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const user = useCurrentUser();
  const { hasHrAccess } = usePermissions();

  // Close the phone menu after navigating (render-time adjustment, no effect)
  const [prevPathname, setPrevPathname] = useState(pathname);
  if (pathname !== prevPathname) {
    setPrevPathname(pathname);
    if (menuOpen) setMenuOpen(false);
  }

  // HR users come back to My view next time if this is where they were
  useEffect(() => {
    if (hasHrAccess) setLastView(user.userId, "me");
  }, [hasHrAccess, user.userId]);

  return (
    <ToastProvider>
      <div className={cx("me-app", styles.layout)}>
        <Navbar onMenu={() => setMenuOpen(true)} />

        <div className={styles.body}>
          {menuOpen && (
            <div
              className={styles.backdrop}
              onClick={() => setMenuOpen(false)}
              aria-hidden="true"
            />
          )}
          <aside
            className={cx(
              styles.aside,
              isCollapsed && !menuOpen && styles.asideCollapsed,
              menuOpen && styles.asideOpen,
            )}
          >
            <Sidebar
              isCollapsed={isCollapsed && !menuOpen}
              onToggleCollapse={() =>
                menuOpen ? setMenuOpen(false) : setIsCollapsed((prev) => !prev)
              }
            />
          </aside>

          <main className={styles.main}>
            <Outlet />
          </main>
        </div>

        {/* First login: ask for location access (once). */}
        <LocationConsentGate />
      </div>
    </ToastProvider>
  );
};

export default Layout;
